// skipcq: JS-W1028
import { useEffect, useState } from 'react';
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../utils/firebase';
import { BEER_ACTIVITY_BY_STATE_REPORTS_COLLECTION } from '../utils/firestoreCollections';

const DAILY_REPORT_LOOKBACK_COUNT = 60;

function useBeerActivityByStateDailyReports() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchReports = async () => {
      try {
        if (!cancelled) {
          setLoading(true);
          setError(null);
        }

        const reportsCollection = collection(db, BEER_ACTIVITY_BY_STATE_REPORTS_COLLECTION);
        const reportsQuery = query(
          reportsCollection,
          where('type', '==', 'daily'),
          orderBy('date', 'desc'),
          limit(DAILY_REPORT_LOOKBACK_COUNT),
        );
        const snapshot = await getDocs(reportsQuery);
        if (cancelled) {
          return;
        }

        const documents = snapshot.docs.map((documentSnap) => {
          const data = documentSnap.data();
          return {
            id: documentSnap.id,
            date: typeof data.date === 'string' ? data.date : '',
            metrics:
              typeof data.metrics === 'object' && data.metrics !== null ? data.metrics : {},
          };
        });
        setRows(documents);
      } catch (fetchError) {
        console.error('useBeerActivityByStateDailyReports fetch error', fetchError);
        if (!cancelled) {
          setError('Failed to load beer activity by state reports');
          setRows([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchReports();
    return () => {
      cancelled = true;
    };
  }, []);

  const latestSnapshot = rows.length > 0 ? rows[0] : null;

  return {
    rows,
    latestSnapshot,
    loading,
    error,
  };
}

export default useBeerActivityByStateDailyReports;
